import { useTranslation } from 'react-i18next';

interface CompanyBadgeProps {
  teamRole: 'ADMIN' | 'AGENT' | 'VIEWER' | 'OWNER';
  companyName?: string;
  size?: 'sm' | 'md';
}

const ROLE_STYLES: Record<string, { bg: string; text: string }> = {
  OWNER: { bg: 'bg-purple-100', text: 'text-purple-700' },
  ADMIN: { bg: 'bg-blue-100', text: 'text-blue-700' },
  AGENT: { bg: 'bg-green-100', text: 'text-green-700' },
  VIEWER: { bg: 'bg-gray-100', text: 'text-gray-600' },
};

const ROLE_LABELS: Record<string, { en: string; ar: string }> = {
  OWNER: { en: 'Company Owner', ar: 'مالك الشركة' },
  ADMIN: { en: 'Company Admin', ar: 'مدير الشركة' },
  AGENT: { en: 'Company Agent', ar: 'وكيل الشركة' },
  VIEWER: { en: 'Company Viewer', ar: 'مشاهد' },
};

export default function CompanyBadge({ teamRole, companyName, size = 'sm' }: CompanyBadgeProps) {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';

  const style = ROLE_STYLES[teamRole] || ROLE_STYLES.VIEWER;
  const label = ROLE_LABELS[teamRole] || ROLE_LABELS.VIEWER;

  return (
    <span
      className={`
        inline-flex items-center gap-1 rounded-full font-medium
        ${style.bg} ${style.text}
        ${size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'}
      `}
      title={companyName}
    >
      <i className="ri-building-2-line" />
      {isRTL ? label.ar : label.en}
    </span>
  );
}
